<template>

             <div class="relative w-full">
                <div class="g-form rounded hover:bg-gray-200 text-sm w-full dark:bg-gray-700 dark:hover:bg-slate-800 dark:border-gray-500 dark:text-gray-200 ">
                  <button @click="toggleDropdown" class="flex w-full py-2 px-2 text-left items-center">
                      <span class="flex items-center whitespace-nowrap text-gray-700  dark:text-gray-400" >
                        {{ currentValue }}
                      </span>
                  </button>         
                  <div class="before-absolute bg-blue-600 transform scale-x-0 transform-origin-center w-full h-[2px] left-0 rounded-[30px] bottom-0 transition-transform duration-300 ease-in-out"></div>    
                  <span>
                     <div v-if="dropdownOpen" @click="toggleDropdown" class="click fixed inset-0 z-10"></div>
                      <div v-if="dropdownOpen" class="absolute z-20 left-0 rounded overflow-hidden w-28" style="box-shadow:0 3px 5px 1px rgba(0,0,0,.2), 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12);">
                          <ul class="left-0 max-h-40 rounded-b w-full overflow-y-auto scrollbar-style z-20 bg-white dark:bg-gray-600 border dark:border-gray-500 dark:text-gray-400" >
                            <li v-for="option in values" :key="option.id">
                                <button v-on:click="selectValue(option)" :class="{ 'bg-blue-100 dark:bg-blue-300': option === currentValue, 'hover:bg-gray-100 dark:hover:bg-gray-500': option.key != currentValue }" class="w-full flex items-center text-left py-2 px-3">
                                    {{ option }}
                                </button>
                            </li>
                          </ul>
                      </div>
                  </span>
                </div>
             </div>
  
</template>

<script>
import Constants from "controllers/vue_components/mixins/constants";
export default {
    name: 'CustomSlotsDropdown',
    mixins: [Constants],
    props: [ 'name', 'selected_value', 'values'],
    data() {
        return {
            currentValue: this.selected_value,
            dropdownOpen: false,
        };
    },
    methods: {
        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen;

        },
        selectValue(option) {
            this.currentValue = option;
            this.$emit('change', { [this.name] : this.currentValue });
            this.dropdownOpen = false;
        },
    },

    computed: {

    },
    watch: {
        selected_value(newValue) {
            this.currentValue = newValue;
        },
    }
};
</script>
